<template>
  <v-layout align-content-start row wrap justify-start>
    <v-flex xs12 class="section-box">
      <full-calendar :events="events" :config="config"></full-calendar>
    </v-flex>
    <div class="text-xs-center">

    </div>
    <v-flex xs12 class="text-xs-center">
      <v-btn round outline color="black" dark
        v-modal-trigger="'showCalendarConfig'">
        <v-icon small left>fal fa-cog</v-icon>
        Configurar agenda
      </v-btn>
    </v-flex>
    <calendar-config></calendar-config>
  </v-layout>
</template>

<script>
import axios from 'axios'
import EventBus from '@/event-bus'
import 'fullcalendar/dist/locale/pt-br'
import AdminCalendarConfig from '@/components/admin/calendar/AdminCalendarConfig'

export default {
  data: () => ({
    events: [],
    config: {
      locale: 'pt-br',
      editable: false,
      eventLimit: true,
      columnFormat: 'dddd',
      timeFormat: 'H(:mm)',
      defaultView: 'month',
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'month,basicWeek,basicDay'
      },
      fixedWeekCount: false,
      eventLimitText: 'mais',
      buttonText: {
        today: 'Hoje', month: 'Mês', week: 'Semana', day: 'Dia', list: 'Lista'
      }
    }
  }),

  methods: {
    loadCalendar (status = '') {
      EventBus.$emit('appLoading', true)
      // eslint-disable-next-line
      let path = API.userAgenda + '/list-events'

      axios.get(path).then(response => {
        this.events = []
        if (response.data.events) {
          this.events = this.formatEvents(response.data.events)
        }

        EventBus.$emit('appLoading', false)
      }).catch(errors => {
        EventBus.$emit('showSnackbar', { message: 'Erro ao carregar a agenda', color: 'error' })
        EventBus.$emit('appLoading', false)
      })
    },

    formatEvents (events) {
      const newEvents = []
      for (let event of events) {
        const newEvent = {
          title: event.summary,
          start: event.start.dateTime,
          end: event.end.dateTime
        }

        newEvents.push(newEvent)
      }

      return newEvents
    }
  },

  beforeDestroy () {
    EventBus.$off('loadCalendar')
  },

  created () {
    this.loadCalendar()
    EventBus.$on('loadCalendar', this.loadCalendar)
  },

  components: {
    'calendar-config': AdminCalendarConfig
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/AdminCalendar.vue